!function () {
  "use strict";

  const ROW_SELECTOR = "[data-timeline-row]";
  const HOLDER_SELECTOR = "[data-timeline-rows]";
  const SELECTED_CLASS = "is-selected";

  function isMobile() {
    return window.innerWidth <= 767;
  }

  customElements.define("timeline-component", class extends HTMLElement {
    constructor() {
      super();
      this.rows = this.querySelectorAll(ROW_SELECTOR);
      this.holder = this.querySelector(HOLDER_SELECTOR);
      this.prevScrollY = window.scrollY;
      this.scrollHandler = () => this.onScroll();
      this.mobileScrollHandler = () => this.onMobileScroll();
    }

    connectedCallback() {
      if (this.rows.length === 0 || !this.holder) return;

      this.rows[0].classList.add(SELECTED_CLASS); // Always keep first selected
      this.attachEvents();
    }

    disconnectedCallback() {
      this.detachEvents();
    }

    attachEvents() {
      if (isMobile()) {
        this.holder.addEventListener("scroll", this.mobileScrollHandler);
      } else {
        window.addEventListener("scroll", this.scrollHandler);
      }

      window.addEventListener("resize", () => this.onResize());
    }

    detachEvents() {
      this.holder.removeEventListener("scroll", this.mobileScrollHandler);
      window.removeEventListener("scroll", this.scrollHandler);
    }

    onResize() {
      this.detachEvents();
      this.attachEvents();
    }

    onScroll() {
      const currentScrollY = window.scrollY;
      const isScrollingDown = currentScrollY > this.prevScrollY;
      const viewportHeight = window.innerHeight;

      this.rows.forEach((row, index) => {
        const rect = row.getBoundingClientRect();
        const rowTop = rect.top;
        const rowHeight = rect.height;

        const midpoint = viewportHeight / 2;
        const distanceFromMid = midpoint - rowTop;
        const progress = Math.max(0, Math.min(1, distanceFromMid / rowHeight));

        // Set --percent-desktop
        row.style.setProperty("--percent-desktop", (progress * 100) + "%");

        // Add/remove is-selected
        if (isScrollingDown && progress >= 0.5) {
          row.classList.add(SELECTED_CLASS);
        } else if (!isScrollingDown && index !== 0 && progress < 0.5) {
          row.classList.remove(SELECTED_CLASS);
        }
      });

      this.prevScrollY = currentScrollY;
    }

    onMobileScroll() {
      const scrollLeft = this.holder.scrollLeft;
      const scrollWidth = this.holder.scrollWidth - this.holder.clientWidth;
      const percentScrolled = Math.max(0, Math.min(1, scrollLeft / scrollWidth));

      this.style.setProperty("--percent-mobile", (percentScrolled * 100) + "%");

      // Optional: Add is-selected class to current visible row
      this.rows.forEach((row, index) => {
        const rect = row.getBoundingClientRect();
        const rowLeft = rect.left;
        const rowWidth = rect.width;
        const center = window.innerWidth / 2;

        if (rowLeft <= center && rowLeft + rowWidth >= center) {
          row.classList.add(SELECTED_CLASS);
        } else if (index !== 0) {
          row.classList.remove(SELECTED_CLASS);
        }
      });
    }
  });
}();
